const amplify = {
  Auth: {
    region: process.env["REACT_APP_COGNITO_REGION"],
    userPoolId: process.env["REACT_APP_COGNITO_USER_POOL_ID"],
    userPoolWebClientId: process.env["REACT_APP_COGNITO_USER_POOL_WEBCLIENT_ID"],
    cookieStorage: {
      domain: window.location.hostname,
      secure: false,
      path: "/",
      expires: 365
    }
  }
};

export default amplify;
